export const formatProjectsToStore = projects =>
  projects.map(project => ({
    id: project?.entity_id,
    name: project?.value
  }));

export const formatProviderTeamsToStore = providerTeams =>
  (providerTeams?.items || []).map(team => ({
    id: team.entity_id,
    name: team.value
  }));

export const formatProviderAreasToStore = providerAreas =>
  (providerAreas?.items || []).map(area => ({
    id: area.entity_id,
    name: area.value
  }));
